import { render } from "./ModalLayout.vue?vue&type=template&id=6e85f972&scoped=true"
import script from "./ModalLayout.vue?vue&type=script&lang=js"
export * from "./ModalLayout.vue?vue&type=script&lang=js"

import "./ModalLayout.vue?vue&type=style&index=0&id=6e85f972&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e85f972"]])

export default __exports__